import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { map } from "rxjs/operators";
import * as _ from 'lodash';
import { BusinessUnit, Country, CacheService, IProcessUnitBusinessBO, IUnitBusinessBO, IEntamapBO } from '@mapfre-tech/amap3';

@Injectable({
  providedIn: 'root'
})

export class ProcessService {

  className = 'ProcessService';
  treeClasified: any;

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getCorporativeMap(businessUnit: IUnitBusinessBO | null, entity: IEntamapBO | null, version = "latest", cache?: any, cacheKey = "corporativeMap"): Observable<IProcessUnitBusinessBO> {
    const params: any = {}
    if (version) {
      params.version = version;
    }
    if (entity) {
      params.entityId = entity.idEntityPk;
    }
    if (this.cacheService.canUseCache(cacheKey, [businessUnit?.idUnitBusinessPk, _.get(entity,'idEntityPk'), version]) && cache) {
      return this.cacheService.getCacheData(cacheKey, [businessUnit?.idUnitBusinessPk, _.get(entity,'idEntityPk'), version]) as object as Observable<IProcessUnitBusinessBO>;
    } else {
      const observable = this.http.get<IProcessUnitBusinessBO>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit?.idUnitBusinessPk}`, { params }).pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey, [businessUnit?.idUnitBusinessPk, _.get(entity,'idEntityPk'), version])
        return res;
      }))
      this.cacheService.updateCacheReq(cacheKey, [businessUnit?.idUnitBusinessPk, _.get(entity,'idEntityPk'), version]);
      return observable;
    }
  }

  getSimpleCorporativeMap(businessUnit: IUnitBusinessBO, version = "latest", cache = true, cacheKey= "simpleCorporativeMap"): Observable<IProcessUnitBusinessBO> {
    const params: any = {}
    if (businessUnit) {
      cacheKey = cacheKey+"_"+businessUnit.idUnitBusinessPk.toString();
    }

    if (version) {
      cacheKey = cacheKey+"_"+version.toString();
      params.version = version;
    }
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IProcessUnitBusinessBO>;
    } else {
      const observable = this.http.get<IProcessUnitBusinessBO>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit.idUnitBusinessPk}`, { params }).pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getLocalMap(businessUnit: IUnitBusinessBO, entityID: number, jobId?: string | null, cache = true, version: any = "latest", cacheKey: any = "localMap"): Observable<IProcessUnitBusinessBO> {
    const params: any = {}
    if (businessUnit) {
      cacheKey = cacheKey+"_"+businessUnit.idUnitBusinessPk.toString()
    }
    if (version) {
      cacheKey = cacheKey+"_"+version.toString()
      params.version = version;
    }
    if (entityID) {
      cacheKey = cacheKey+"_"+entityID.toString()
    }
    if (jobId) {
      cacheKey = cacheKey+"_"+jobId.toString()
    }

    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IProcessUnitBusinessBO>;
    } else {
      const observable = this.http.get<IProcessUnitBusinessBO>(`${environment.base_URL}/business-processes/business-process-unit/${businessUnit.idUnitBusinessPk}/country-process/${entityID}`, { params }).pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey)
        return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getProcess(readonly: any, businessUnit: IUnitBusinessBO, version = "latest") {
    if (!readonly) {
      return this.getSimpleCorporativeMap(businessUnit, version).pipe(map(res => {
        this.treeClasified = {};
        this.prepareNodes(res);
        return this.treeClasified;
      }))
    }
    return of(false);
  }

  getSubprocess(readonly: any, businessUnit: IUnitBusinessBO, version = "latest") {
    if (!readonly) {
      return this.getSimpleCorporativeMap(businessUnit, version).pipe(map(res => {
        this.treeClasified = {};
        this.prepareNodes(res);
        return this.treeClasified['SUB_PROCESO'];
      }))
    }
    return of(false);
  }


  prepareNodes(tree: any) {
    _.map(tree, (node: any) => {
      if (!_.find(_.keysIn(this.treeClasified), it => it === node.data.typeProcess.cdTypeProcess)) {
        _.assign(this.treeClasified, { [node.data.typeProcess.cdTypeProcess]: [node.data] });
      }
      else {
        if (!_.find(this.treeClasified[node.data.typeProcess.cdTypeProcess], (it: any) => it.idProcessPk === node.data.idProcessPk)) {
          this.treeClasified[node.data.typeProcess.cdTypeProcess].push(node.data);
        }
      }

      if (node.children) {
        this.prepareNodes(node.children);
      }
    });
  }

  // TODO: country -> entity
  saveMap(businessUnit: IUnitBusinessBO, entity: IEntamapBO, map: any) {
    const pathParams = entity ? `${businessUnit.idUnitBusinessPk}/${entity.idEntityPk}` : `${businessUnit.idUnitBusinessPk}`
    const cleanMap = this.cleanTree(map, entity);
    return this.http.post(`${environment.base_URL}/business-processes`, cleanMap);
  }

  cleanTree(tree: any, entity: IEntamapBO) {
    return _.map(tree, (n) => {
      return this.cleanNodeDepth(n, entity);
    })
  }

  cleanNodeDepth(node: any, entity: IEntamapBO) {
    delete node.parent;
    node.data.size = _.get(node, 'form.value.size') ? Number(_.get(node, 'form.value.size')) : Number(_.get(node,'data.size')) > 0 ? Number(_.get(node,'data.size')) : 0;
    node.data.entamap = entity;
    if (node.data.entity) {
      delete node.data.entity;
    }
    delete node.form;
    if (node.children) {
      node.children = _.map(node.children, (c) => {
        return this.cleanNodeDepth(c, entity);
      })
    }
    return node
  }

  deleteCache() {

    const memoryCache = ["process", "processMap"];

    _.forEach(memoryCache, item => {
      this.cacheService.deleteCache(item);
    })

  }
}

